// extracted by mini-css-extract-plugin
export default {"wrapper":"Video_wrapper__Mh811"};